import { HelperResult, JurySessionAssessment } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useJurySessionAssessments } = getCRUDHooks({
  entityName: 'jurySessionAssessments',
  get: ({ userId, learningPathId }): HelperResult<JurySessionAssessment[]> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .jurySessionAssessments.find({ learningPathId }),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useJurySessionAssessments,
};
